import React from 'react';
import PropTypes from 'prop-types';
import FullScreenPopup from '../FullScreenPopup';
import ContentContainer from '../ContentContainer';
import LocaleText from '../LocaleText';

class StaticPenLegend extends React.Component {
    render() {
        const { locale } = this.props;
        const classes = ['StaticPenLegend', ...this.props.classes];
        return (
            <FullScreenPopup
                isOpen={this.props.isOpen}
                toggle={this.props.onClose}
                extraClasses={classes}
            >
                <ContentContainer>
                    <h1 className="StaticPenLegend__title">
                        <LocaleText textKey="static.pen.legend.title" />
                    </h1>
                    <section className="StaticPenLegend__section StaticPenLegend__section--material">
                        <h2 className="StaticPenLegend__section-title">
                            <LocaleText textKey="static.pen.legend.material.title" />
                        </h2>
                        <table>
                            <tbody>
                                <tr>
                                    <td>G</td>
                                    <td>
                                        <LocaleText textKey="static.pen.legend.material.g" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>L</td>
                                    <td>
                                        <LocaleText textKey="static.pen.legend.material.l" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>M</td>
                                    <td>
                                        <LocaleText textKey="static.pen.legend.material.m" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>O</td>
                                    <td>
                                        <LocaleText textKey="static.pen.legend.material.o" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>T</td>
                                    <td>
                                        <LocaleText textKey="static.pen.legend.material.t" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </section>
                    <section className="StaticPenLegend__section StaticPenLegend__section--color-keys">
                        <h2 className="StaticPenLegend__section-title">
                            <LocaleText textKey="static.pen.legend.color.keys.title" />
                        </h2>
                        <p>
                            <LocaleText textKey="static.pen.legend.color.keys.description.one" />
                        </p>
                        <img
                            src="/storage/assets/static-pen-legend/color_keys_legend_2x.png"
                            alt=""
                        />
                        <p>
                            <LocaleText textKey="static.pen.legend.color.keys.description.two" />
                        </p>
                    </section>
                    <section className="StaticPenLegend__section StaticPenLegend__section--colors">
                        <h2 className="StaticPenLegend__section-title">
                            <LocaleText textKey="static.pen.legend.colors.title" />
                        </h2>
                        <p>
                            <LocaleText textKey="static.pen.legend.colors.description" />
                        </p>
                        <img
                            src={`/storage/assets/static-pen-legend/color_legend_desktop_${locale}_2x.png`}
                            alt=""
                            className="desktop-image"
                        />
                        <img
                            src={`/storage/assets/static-pen-legend/color_legend_mobile_${locale}_2x.png`}
                            alt=""
                            className="mobile-image"
                        />
                    </section>
                </ContentContainer>
            </FullScreenPopup>
        );
    }
}

StaticPenLegend.propTypes = {
    classes: PropTypes.arrayOf(PropTypes.string),
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
    locale: PropTypes.string,
};

StaticPenLegend.defaultProps = {
    classes: [],
    isOpen: false,
    locale: 'de',
};

export default StaticPenLegend;
